module.exports = __webpack_public_path__ + "img/consent_grace.d6193e46.svg";